import { useRef } from "react";
import { Col, Row, Form, Button } from "react-bootstrap";
import "./DRFilterBox.css"
import { lddGlobalSessionInfo } from "../../../Components/navigationTypes";
import { useAppSelector } from "../../../redux/hooks";
import { DRFileType, DRMessageStatuses } from "./DRlistFuncs";
import { isPageInDR } from "../drFuncs";


export interface DRFilterProps {
    Types: DRFileType[];
    Status: boolean;
    Lawyer: string;
    MortgageStatuses: string[];
}

const DRFilterBox: React.FC<{
    filter: DRFilterProps,
    setFilter: (args: DRFilterProps) => void,
    setShowFilters: (show: boolean) => void,
    modalType?: string
}> = (props) => {
    const SESSION_INFO: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    const drSearchRef = useRef(null);
    const page = useAppSelector((state) => state.currentNavigation?.page);
    const getFilterTypes = () => {
        if (isPageInDR(page)) {
            return ["New Home", "Lender"];
        }
        
        return props.modalType && props.modalType === 'mortgage' 
            ? ["Lender", "LLC"]
            : ["New Home", "Lender", "LLC"];
    };

    function handleFormChange(e) {
        switch (e.target.dataset?.group) {
            case "Type":
                props.setFilter({ ...props.filter, Types: e.target.checked ? [...props.filter.Types, e.target.name] : [...props.filter.Types.filter(v => v !== e.target.name)]});
                break;
            case "Status":
                props.setFilter({ ...props.filter, Status: !props.filter.Status});
                break;
            case "Lawyer":
                props.setFilter({ ...props.filter, Lawyer: e.target.value});
                break;
            case "MortgageStatus":
                props.setFilter({ ...props.filter, MortgageStatuses: e.target.checked ? [...props.filter.MortgageStatuses, e.target.name] : [...props.filter.MortgageStatuses.filter(v => v !== e.target.name)]});
                break;
        }
    }

    function handleClearAll() {
        props.setFilter({
            Types: [], MortgageStatuses: [],
            Status: false,
            Lawyer: ""
        });
    }

    return <div ref={drSearchRef} className="overlay" id="filterSearchBox">
        <Form.Group className="mb-3 mt-2" onChange={(e) => {handleFormChange(e)}}>
            <div id="adSearchContainer">
                <Row className="mb-3">
                    <Col className="col-12">
                        <h2><i className="fa-solid fa-bars-filter"></i>Filters</h2>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col className="col-12">
                        <Form.Label>
                            <h3>
                                <i className="fa-duotone fa-solid fa-circle-arrow-right"></i>
                                Type
                            </h3>
                        </Form.Label>
                        {getFilterTypes().map(name => {
                            const fileType = name as DRFileType;
                            return <CheckBox dataGroup="Type" name={name} checked={props.filter.Types?.includes(fileType)} key={name} />    
                        })}
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Form.Label>
                            <h3>
                                <i className="fa-solid fa-circle status-warning"></i>
                                Status
                            </h3>
                        </Form.Label>
                        <Form.Switch
                            className="ms-4 mt-2"
                            data-group="Status"
                            id="status-toggle"
                            label="New"
                            key="New"
                            checked={props.filter.Status}
                            onChange={(e) => handleFormChange(e)}
                        />
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Form.Label><h3><i className="fa-duotone fa-solid fa-user-tie"></i>Lawyer</h3></Form.Label>
                        <Form.Select
                            className="ms-4 mt-2 dropdown-text"
                            data-group="Lawyer"
                            value={props.filter.Lawyer ?? ""}
                            onChange={null}
                        >
                            <option value="">- All Lawyers -</option>
                            {SESSION_INFO.firm.Lawyers.map(lawyer =>
                                <option key={lawyer.LSUCID} value={lawyer.LSUCID} label={`${lawyer.FirstName} ${lawyer.LastName}`}>{lawyer.LSUCID}</option>
                            )}
                        </Form.Select>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <Form.Label>
                            <h3>
                                <i className="fa-duotone fa-solid fa-circle-check"></i>
                                Mortgage Instruction Status
                            </h3>
                        </Form.Label>
                        {DRMessageStatuses.map(name => {
                            return <CheckBox dataGroup="MortgageStatus" name={name} checked={props.filter.MortgageStatuses?.includes(name)} key={name} />    
                        })}
                    </Col>
                </Row>
                <Row className="mb-1" style={{minHeight: "25px"}}>
                    <Col>
                        <Button onClick={handleClearAll} variant="text" style={{position: "absolute", left: "10px", padding: "7px"}}>Clear All</Button>
                        <Button onClick={() => props.setShowFilters(false)} variant="primary" style={{position: "absolute", right: "10px", padding: "7px"}}>Close</Button>
                    </Col>
                </Row>
            </div>
        </Form.Group>
    </div>
}

const CheckBox = ({dataGroup, name, checked}) => {
    return <Form.Check
        className="ms-4 mt-2"
        type="checkbox"
        data-group={dataGroup}
        name={name}
        label={name}
        checked={checked}
        onChange={null}
    />
}

export default DRFilterBox;